import { Component } from '@angular/core';

@Component({
  selector: 'allas-que-puedes-cotizar',
  imports: [],
  template: `
    <section class="flex flex-col gap-2 mt-12">
      <h2
        class="text-3xl xl:text-5xl font-bold fs-condensed text-center text-appBlack"
      >
        ¿Qué puedes cotizar?
      </h2>
      <div class="mt-8 grid grid-cols-1 xl:grid-cols-3 gap-8">
        @for (item of items; track item) {
        <article
          class="flex gap-2 items-center w-full bg-[#f3f4f6] shadow-md px-4 py-3 xl:max-w-[70%] mx-auto"
        >
          <img src="/allas-icons/circle-check.svg" alt="car" class="w-6 h-6" />
          <p class="text-lg fs-condensed text-appBlack">{{ item }}</p>
        </article>
        }
        <span class="hidden xl:block"></span>
        <span
          class="bg-appPrimary-500 text-white px-4 py-3 xl:max-w-[70%] mx-auto w-full flex items-center justify-center fs-condensed text-lg font-light"
        >
          MUCHO MÁS
        </span>
        <span class="hidden xl:block"></span>
      </div>
    </section>
  `,
})
export class QuePuedesCotizar {
  public items = [
    'Baterías',
    'Filtros de Aceite y Aire',
    'Alternadores',
    'Bujías de Encendido',
    'Pastillas y Discos de Freno',
    'Amortiguadores',
    'Aceites y Lubricantes',
    'Motores de Arranque',
    'Partes de Suspensión',
  ];
}
